module.exports = __webpack_public_path__ + "img/20a75f1eca964d87f032f31df00ecfcc.png";